import {
    TextInput,
    ReferenceInput,
    ReferenceArrayInput,
    SelectInput,
    maxLength,
    AutocompleteInput,
    AutocompleteArrayInput,
    NumberInput,
    useTranslate,
} from 'react-admin';
import { Box } from '@mui/material';
import FormDialog from '@/components/global/drawers/FormDialog.jsx';
import { noCharactersFromList } from '@/components/global/validators/customValidators.jsx';
import { boolChoices, productStatusChoices, productColorChoices } from '@/components/global/options/selectOptions.jsx';
import { BulkActionsContainer } from '@/components/global/buttons/bulkButtons.jsx';
import { currencyChoices } from '@/components/product/currencyChoices.js';
import { useTagNameSource } from '@/i18n/hooks.js';

export const ProductBulkActions = () => {
    const translate = useTranslate();
    const tagNameSource = useTagNameSource();
    const filterToQuery = searchText => ({
        search: {
            value: searchText,
            fields: {
                name: true,
            },
        },
    });

    return (
        <BulkActionsContainer>
            <FormDialog title={translate('common.update')}>
                <Box className='autocomplete-parent'>
                    <ReferenceArrayInput source='tagIds' reference='tag' label={translate('resources.product.fields.tags')} perPage={25}>
                        <AutocompleteArrayInput
                            optionText={tagNameSource}
                            filterToQuery={searchText => ({
                                search: {
                                    value: searchText,
                                    fields: {
                                        name: true,
                                        nameEn: true,
                                    },
                                },
                            })}
                            fullWidth={true}
                            disablePortal={true}
                        />
                    </ReferenceArrayInput>
                </Box>
                <Box className='autocomplete-parent'>
                    <ReferenceInput source='materialId' reference='material' perPage={25}>
                        <AutocompleteInput
                            filterToQuery={filterToQuery}
                            fullWidth
                            disablePortal={true}
                            label={translate('resources.product.fields.material')}
                        />
                    </ReferenceInput>
                </Box>
                <Box className='autocomplete-parent'>
                    <AutocompleteInput source='status' choices={productStatusChoices(translate)} fullWidth disablePortal={true} />
                </Box>
                <TextInput source='owner' validate={[maxLength(255, translate('common.validation.maxLength', { count: 255 }))]} fullWidth />
                <SelectInput source='ownerContractor' choices={boolChoices(translate)} emptyText={translate('common.all')} fullWidth />
                <TextInput
                    source='brand'
                    validate={[maxLength(255, translate('common.validation.maxLength', { count: 255 })), noCharactersFromList('$^*()/\\"\'`|<>,.[]{}')]}
                    fullWidth
                />
                <NumberInput source='volume' min={0} max={10000} fullWidth />
                <SelectInput source='materialColor' choices={productColorChoices(translate)} emptyText={translate('common.all')} fullWidth />
                <SelectInput source='reusable' choices={boolChoices(translate)} emptyText={translate('common.all')} fullWidth />
                <NumberInput source='deposit' min='0.00' step='0.01' fullWidth />
                <SelectInput source='currency' choices={currencyChoices} emptyText={translate('common.all')} fullWidth />
                <TextInput source='operatorId' validate={[maxLength(30, translate('common.validation.maxLength', { count: 30 }))]} fullWidth />
                <TextInput source='pictureUrl' fullWidth />
            </FormDialog>
        </BulkActionsContainer>
    );
};
